"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerReducer = exports.docAgreementReducer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var headerReducer = function headerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    default:
      return state;
  }
};
exports.headerReducer = headerReducer;
var docAgreementReducer = function docAgreementReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isDocumentViewed: false,
    iframeURL: 'https://c.comenity.net/yourtuitionsolution/common/Legal/disclosures.xhtml',
    BROWSER_SUPPORT_MESSAGE: _constants.BROWSER_SUPPORT_MESSAGE,
    application: {},
    isAgreementChecked: false,
    data: '',
    navigationToNextPage: false,
    error: false,
    disclosureCopy: {
      patient: 'By clicking "Confirm and Apply” below, I am electronically signing this application.',
      practice: 'By clicking "Confirm and Apply" below, I agree that I have provided the Comenity Capital Bank Terms & Conditions to the applicant and they have consented to submit their application electronically, which will be considered a written application.'
    }
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _constants.UPDATE_FORM_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAgreementChecked: action.payload.isAgreementChecked,
        error: action.payload.error
      });
    case _constants.VALIDATE_AND_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        navigationToNextPage: action.payload.navigationToNextPage,
        redirectURL: action.payload.redirectURL,
        error: action.payload.error
      });
    default:
      return state;
  }
};
exports.docAgreementReducer = docAgreementReducer;
